import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import type { SessionUser } from "../lib/types";

export function ProtectedRoute() {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    void api<{ user: SessionUser }>("/api/auth/session").then((res) => {
      if (!mounted) return;
      setAuthorized(res.ok);
      setLoading(false);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return <div className="animate-pulse rounded-2xl border border-border bg-surface p-8">Checking session...</div>;
  }

  if (!authorized) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
